import MD5 from "crypto-js/md5"

export const getDisqusConfig = (post: any) => {
  let disqusId = post.frontmatter?.disqus
  if (!disqusId) {
    disqusId = `${MD5(post.fields.path)}`
  }
  return {
    url: `https://spring.io/blog/${post?.fields?.path}`,
    identifier: disqusId,
    title: post.frontmatter.title,
  }
}

export const getAuthor = (post: any, authors: Array<any>) => {
  const find = authors.find(a => a.fields.slug === post.frontmatter.author)
  return {
    inactive: find?.frontmatter?.inactive,
    title: find?.frontmatter?.title,
    slug: find?.fields?.slug,
  }
}
